module.exports = __webpack_public_path__ + "img/footer-logo 1.41be11bc.svg";